import { render } from "./RubricPage.vue?vue&type=template&id=614d0195&scoped=true"
import script from "./RubricPage.vue?vue&type=script&lang=js"
export * from "./RubricPage.vue?vue&type=script&lang=js"

import "./RubricPage.vue?vue&type=style&index=0&id=614d0195&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-614d0195"]])

export default __exports__